module.exports = __webpack_public_path__ + "static/media/ModalEmail.2855070a.svg";